module.exports = __webpack_public_path__ + "img/Harrods1.06c7654c.png";